<div class="mobicred-login-container flex flex-col sm:block justify-center items-center sm:mt-2 w-full mat-typography" [ngClass]="mobile ? 'mt-3' : 'mt-6' ">
    <div class="payment-method-description-container flex justify-center items-center w-full sm:mt-12 mb-2">
        <p class="payment-method-description m-0 md:text-lg lg:text-lg xl:text-md w-4/5 text-center" *ngIf="!login">
            Provide Mobicred login details
        </p>
        <p class="payment-method-description m-0 md:text-lg lg:text-lg xl:text-md w-4/5 text-center" *ngIf="login">
            Verifying your credentials...
        </p>
    </div>


    <div class="flex flex-wrap bg-gray-300 justify-center items-center pl-2 pr-2 mr-0 ml-0 sm:ml-12 sm:mr-12 min-h-100" style="border-radius: 12px;" [ngClass]="[loading ? 'pt-6' : 'pt-2', mobile ? 'pb-2 mb-2 w-5/6' : 'pb-6  mb-4']">

        <div class="container flex justify-center items-center w-100">
            <mat-spinner
              *ngIf="loading"
              class="loading-spinner"
              [color]="color"
              [diameter]="diameter"
            >
            </mat-spinner>
          </div>

        <div class="form-container w-100" *ngIf="!loading">

            <form [formGroup]="loginForm" class="flex flex-wrap flex-row items-center justify-evenly">

                <mat-form-field appearance="standard" class="w-11/12 sm:w-2/5 relative">
                    <mat-label>Username</mat-label>
                    <input
                        (click)="resetValidation()"
                        matInput
                        placeholder="email@example.com"
                        formControlName="username"
                        required
                        [errorStateMatcher]="matcher"
                    >
                    <mat-error *ngIf="showErrors">
                        Please enter {{(usernameControl.value.name ? usernameControl.value.name : 'a valid email')| lowercase}}.
                    </mat-error>
                    </mat-form-field>

                <mat-form-field appearance="standard" class="w-11/12 sm:w-2/5 relative">
                    <mat-label>Password</mat-label>
                    <input
                        (click)="resetValidation()"
                        matInput
                        [type]="hide ? 'password' : 'text'"
                        required
                        formControlName="password"
                        [errorStateMatcher]="matcher"
                    >
                    <mat-error *ngIf="showErrors">
                        Please enter {{(passwordControl.value.name ? passwordControl.value.name : 'a valid password')| lowercase}}.
                    </mat-error>
                    <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                </mat-form-field>

            </form>

            <div class="button-container flex justify-center" [ngClass]="mobile ? 'flex-col-reverse' : 'flex-row'">

              <div class="flex justify-center items-center flex-col confirm-container" [ngClass]="mobile ? 'mr-0 mb-1 mt-0' : 'mr-4 mb-4 mt-2 pl-2'">
                <button [disabled]="loading" class="text-xl font-medium rounded-lg continue-button pl-16 pr-16 flex items-center mt-2 flex justify-center" [ngClass]="mobile ? 'w-11/12' : '' " [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + headerColor }" mat-button (click)="cancelTransaction()">
                  <p class="p-0 m-0">CANCEL</p>
                </button>
              </div>

              <div class="flex justify-center items-center flex-col confirm-container" [ngClass]="mobile ? 'mr-0 mb-1 mt-0' : 'mb-4 mt-2 ml-4'">
                <button class="text-lg text-white h-12 mt-2 rounded-lg" [ngStyle]="{'background-color': headerColor}" (click)="formValidation()" [ngClass]="mobile ? 'w-11/12' : 'w-56' ">
                  <strong>CONTINUE</strong>
                </button>
              </div>

            </div>
        </div>

    </div>

    <div class="payment-method-description-container flex justify-center items-center w-full mb-12" *ngIf="!login">
        <p class="payment-method-description md:text-lg lg:text-lg xl:text-md h-8 w-3/5 text-center">
          Need a mobicred account? <a href="{{mobicredUrl}}" target="_top" ><u>Apply Here!</u></a>
        </p>
    </div>
</div>
